import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosInstance from "@/api/axios";
import { useLoading } from "@/contexts/LoadingContext";
import axios from "axios";
import RedirectIcon from "@/assets/RedirectIcon.svg";
import { User } from "@/features/auth/types";
import { AppDispatch } from "@/store";
import { useDispatch } from "react-redux";
import { setUser, toggleQuestion } from "@/features/auth/UserSlice";
import { setSubscriptionDetails } from "@/features/plans-and-subscription/subscriptionSlice";
import { requestForToken } from "@/firebase";

const RedirectUserLogin = () => {
  const { token } = useParams();
  const { setLoading } = useLoading();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [errorTitle, setErrorTitle] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;

    const redirectCall = async () => {
      try {
        setLoading(true);
        console.log("Redirect token:", token);

        const response = await axiosInstance.post(
          "/user/api/v1/admin/users/loginAsUser",
          { loginSecret: token },
          {
            headers: {
              "basic-auth-only": "true",
            },
          }
        );

        const statusCode = response.data?.statusCode;

        if (statusCode === 200) {
          if (response.data.data && response.data.data.accessToken) {
            const user = response.data.data as User;
            if (user) {
              dispatch(setUser(user));
              if (user.subscription_details) {
                dispatch(setSubscriptionDetails(user.subscription_details));
              }
              dispatch(toggleQuestion(user.questionnaireFilled));
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("accessToken", user.accessToken);
              requestForToken();
              navigate("/dashboard/explore_leads");
            }
          }
          console.log("Redirecting to", response.data?.data);
        } else {
          console.error("Unexpected response structure:", response.data);
          setErrorTitle(response.data?.message || "Something went wrong");
        }
      } catch (error) {
        console.error("Error during redirect:", error);

        if (axios.isAxiosError(error)) {
          const status = error.response?.status;
          if (status && status >= 400 && status < 500) {
            setErrorTitle(error.response?.data?.message);
            return;
          }
        }
        setErrorTitle("Unexpected error occurred.");
      } finally {
        setLoading(false);
      }
    };

    redirectCall();
  }, [token, setLoading]);

  return (
    <div>
      {errorTitle && (
        <div className="flex flex-col items-center justify-center h-screen space-y-4">
          <img src={RedirectIcon} alt="Card Break" />
          <h1 className="text-[24px] w-[70%] md:w-[35%] xl:w-[25%] 2xl:w-[18%]  mx-auto text-center text-[#363636]">
            {errorTitle}
          </h1>
        </div>
      )}
    </div>
  );
};

export default RedirectUserLogin;
